const { DateTime, Interval } = require("luxon");

const { CUSTOMER_STATUS } = require("../constants");
const { fbTsToDate } = require("../common/date");

function mapPax(firebase, reservations, slot, durationOfBooking = 60) {
  const slotStart = slot.start;
  const slotEnd = slot.end;
  const slotInterval = Interval.fromDateTimes(slotStart, slotEnd);
  const currentPax = reservations.reduce((total, reservation) => {
    const duration = reservation.durationOfBooking || durationOfBooking;
    const reservationDateTime = DateTime.fromJSDate(
      fbTsToDate(firebase, reservation.dateTime)
    );
    const reservationEnd = reservationDateTime.plus({ minutes: duration });
    const reservationInterval = Interval.fromDateTimes(
      reservationDateTime,
      reservationEnd
    );
    const overlaps = slotInterval.overlaps(reservationInterval);

    if (overlaps) return total + Number(reservation.partySize || 0);

    return total;
  }, 0);

  return { ...slot, currentPax };
}

function getMaxCapacity(business) {
  if (business.maxCapacity) {
    const maxCapacity = business.maxCapacity;
    if (maxCapacity) {
      const overflow = business.overflowCapacity || 0;
      return maxCapacity + overflow;
    }
    return maxCapacity;
  }
  return null;
}

const getReservations = async (firebase, businessUid, date) => {
  const startOfDate = DateTime.fromJSDate(date).startOf("day");
  const endOfDate = startOfDate.endOf("day");
  const snap = await firebase
    .firestore()
    .collection(`reservations/business/${businessUid}`)
    .where("dateTime", ">", startOfDate.toJSDate())
    .where("dateTime", "<", endOfDate.toJSDate())
    .get();
  let reservations = snap.docs.map((doc) => ({
    uid: doc.id,
    ...doc.data(),
  }));
  reservations = reservations.filter(
    (reservation) =>
      reservation.status !== CUSTOMER_STATUS.CANCELLED &&
      reservation.status !== CUSTOMER_STATUS.DELETED &&
      reservation.status !== CUSTOMER_STATUS.REMOVED
  );
  return reservations;
};

module.exports = async function getCapacitySlots(
  firebase,
  business,
  date,
  slotsArr
) {
  const businessUid = business.uid;
  let durationOfBooking = null;
  if (business.settings) {
    durationOfBooking = business.settings.durationOfBooking || 60;
  }
  if (!business) return;
  const maxCapacity = getMaxCapacity(business);

  const reservations = await getReservations(firebase, businessUid, date);
  let slots = slotsArr.map((slot) =>
    mapPax(firebase, reservations, slot, durationOfBooking)
  );
  slots = slots.map((slot) => ({
    ...slot,
    ...(maxCapacity && { maxCapacity }),
  }));

  return { loading: false, slots };
};
